/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RiskPriorityDetailsDto } from '../../models/risk-priority-details-dto';

export interface UpdateRiskPriority$Params {

/**
 * The customer id
 */
  customerId: number;

/**
 * the risk priority details id
 */
  riskPriorityDetailsId: number;
      body: RiskPriorityDetailsDto
}

export function updateRiskPriority(http: HttpClient, rootUrl: string, params: UpdateRiskPriority$Params, context?: HttpContext): Observable<StrictHttpResponse<RiskPriorityDetailsDto>> {
  const rb = new RequestBuilder(rootUrl, updateRiskPriority.PATH, 'put');
  if (params) {
    rb.path('customerId', params.customerId, {});
    rb.path('riskPriorityDetailsId', params.riskPriorityDetailsId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RiskPriorityDetailsDto>;
    })
  );
}

updateRiskPriority.PATH = '/customers/{customerId}/risk-priority-details/{riskPriorityDetailsId}';
